// eslint-disable-next-line
export const Events = {
	// Standard DOM events
	CLICK: 'click',
	LOAD: 'load',

	// address store events
	ADDRESS_STORE_CHANGED: 'address::store::changed',
	ADDRESS_STORE_SUBSCRIBED: 'address::store::subscribed',
	ADDRESS_STORE_UPDATE: 'address::store::update',

	// ink & toner assisted search events
	INKTONER_STORE_CHANGED: 'inkToner::store::changed',
	INKTONER_STORE_SUBSCRIBED: 'inkToner::store::subscribed',
	INKTONER_STORE_UPDATE: 'inkToner::store::update',
	INKTONER_STORE_CREATED: 'inkToner::store::created',
	INKTONER_DROPDOWN_CHANGED: 'inkToner::dropdown::changed',

	// choices.js events
	CHOICES_CHOICE: 'choice',

	// fieldControl.js
	VALIDATION: 'validation',

	// Analytics / Core Metrics
	ACCOUNT_LINK_CHECKOUT_START: 'accountLink::checkout::start',
	ACCOUNT_LINK_CHECKOUT_END: 'accountLink::checkout::end',

	// Bazaar Voice
	BAZAAR_VOICE_LOADED: 'bazaarVoice::loaded',

	// Global JS errors
	GLOBAL_JS_ERROR_REPORTED: 'window::onerror::occurred',
	// Reorder
	ADD_PRODUCTS_SELECTED_PRODUCTS_CHANGED: 'reorder::selectedProducts::changed',
	ADD_PRODUCTS_SELECTED_PRODUCTS_UPDATE: 'reorder::selectedProducts::update',

	// Add to list
	ADD_TO_LIST_BTN_CLICK_END: 'addToList::btnClick::end',
	ADD_TO_LIST_SUBMIT_END: 'addToList::submit::end',
};

export const GtmTrackingType = {
	PRODUCT_CLICK: 'gtm_product_click',
	PRODUCT_IMPRESSION_VIEW: 'gtm_product_impression_view',
	ADD_TO_BASKET: 'gtm_add_to_basket',
	BUNDLE_ADD_TO_BASKET: 'gtm_bundle_add_to_basket',
	UPDATE_BASKET: 'gtm_update_basket',
	REMOVE_FROM_BASKET: 'gtm_remove_from_basket',
	REMOVE_ALL_FROM_BASKET: 'gtm_remove_all_from_basket',
	PRODUCT_DETAIL_VIEW: 'gtm_product_detail_view',
	IMPULSIVE_BUY: 'gtm_impulsive_buy',
	PROMO_CLICK: 'gtm_promo_click',
	PROMO_VIEWS: 'gtm_promo_views',
	PURCHASE: 'gtm_purchase',
	BASKET_FREE_GIFT: 'gtm_basket_free_gift',
	EVENT_CLICK: 'gtm_event_click',
	CHECKOUT_VIEW: 'gtm_checkout_view',
	REGISTRATION_VIEW: 'gtm_registration_view',
	REORDER_ADD_TO_BASKET: 'gtm_reorder_add_to_basket',
};
